import React from "react";
import {
  FaWhatsapp,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";
import { RiTwitterXLine } from "react-icons/ri"; // NEW


const socialLinks = [
  {
    icon: <FaWhatsapp />,
    url: "https://wa.me/919654323500",
    color: "bg-green-500",
    label: "WhatsApp",
  },
  {
    icon: <FaFacebookF />,
    url: "https://www.facebook.com/ajeevidigitaal",
    color: "bg-blue-600",
    label: "Facebook",
  },
  {
    icon: <RiTwitterXLine />,
    url: "https://twitter.com/ajeevidigital",
    color: "bg-sky-500",
    label: "Twitter",
  },
  {
    icon: <FaLinkedinIn />,
    url: "https://linkedin.com/company/techajeevi/posts/?feedView=all",
    color: "bg-blue-700",
    label: "LinkedIn",
  },
  {
    icon: <FaInstagram />,
    url: "https://instagram.com/ajeevidigital",
    color: "bg-pink-500",
    label: "Instagram",
  },
];

const SocialMediaSidebar = () => {
  return (
    <div className="fixed top-[30%] right-0 z-50 flex flex-col items-center space-y-1 pr-0">
      {socialLinks.map((link, index) => (
        <a
          key={index}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`text-white p-3 text-2xl rounded-full shadow-lg hover:scale-110 transition-transform duration-300 ${link.color}`}
          aria-label={link.label}
        >
          {link.icon}
        </a>
      ))}
    </div>
  );
};

export default SocialMediaSidebar;
